export default {
  faPlaidIcon: {
    prefix: 'fas',
    iconName: 'plaid-icon',
    icon: [
      32,
      32,
      [],
      null,
      'M12.688 0l-9.903 2.568-2.729 9.861 3.413 3.47-3.469 3.413 2.569 9.904 9.861 2.728 3.469-3.413 3.413 3.469 9.903-2.568 2.729-9.862-3.413-3.469 3.469-3.413-2.569-9.905-9.862-2.728-3.468 3.413zM6.611 4.465l5.217-1.354 2.281 2.319-3.327 3.273zM18.063 5.461l2.318-2.28 5.194 1.437-4.239 4.17zM3.181 11.62l1.437-5.194 4.17 4.239-3.326 3.273-2.281-2.319zM23.296 10.782l4.239-4.172 1.352 5.217-2.317 2.281zM12.742 10.696l3.327-3.273 3.273 3.327-3.326 3.273zM7.423 15.93l3.326-3.273 3.275 3.327-3.328 3.273zM17.977 16.016l3.326-3.273 3.273 3.327-3.327 3.273zM3.111 20.173l2.319-2.282 3.273 3.328-4.238 4.17zM12.657 21.25l3.327-3.273 3.273 3.327-3.326 3.273zM23.21 21.336l3.327-3.273 2.281 2.318-1.436 5.194zM6.425 27.383l4.239-4.172 3.275 3.327-2.319 2.282-5.194-1.438zM17.891 26.57l3.326-3.273 4.171 4.239-5.216 1.353z',
    ],
  },
};



// WEBPACK FOOTER //
// ./src/assets/icons/icons.js